export const STOCK_LIST = 'STOCK_LIST'
export const STOCK_TRENDING_LIST = 'STOCK_TRENDING_LIST'
export const STOCK_QUOTE = 'STOCK_QUOTE'
export const STOCK_FINANCIAL_CARD = 'STOCK_FINANCIAL_CARD'
export const SET_CHART_DATA = 'SET_CHART_DATA'
export const TOGGLE_CHART_MODAL = 'TOGGLE_CHART_MODAL'
export const STOCK_SHAREHOLDER = 'STOCK_SHAREHOLDER'
export const STOCK_FUND_QUOTE = 'STOCK_FUND_QUOTE'
export const STOCK_NAV = 'STOCK_NAV'
export const STOCK_NAV_1D = 'STOCK_NAV_1D'
export const STOCK_PERIOD = 'STOCK_PERIOD'
export const STOCK_GRAPH_PERIOD = 'STOCK_GRAPH_PERIOD'
export const STOCK_UNIT_TYPE = 'STOCK_UNIT_TYPE'
export const STOCK_RANKING = 'STOCK_RANKING'
export const STOCK_CATEGORIES = 'STOCK_CATEGORIES'
export const STOCK_FOLLOWING = 'STOCK_FOLLOWING'
export const STOCK_TIMESTAMP_1D = 'STOCK_TIMESTAMP_1D'

